import React from "react";
import CountCard from "./components/CountCard";
import { StickyNote, UserRound, List } from "lucide-react";

export default function Page() {
  return (
    <main className="container mt-4">
      <h2 className="fw-bold mb-4">Admin Dashboard</h2>
      <div className="row g-3">
        <div className="col-md-4">
          <CountCard name="Posts" path="posts" icon={<StickyNote />} />
        </div>
        <div className="col-md-4">
          <CountCard name="Magazines" path="magazines" icon={<StickyNote />} />
        </div>
        <div className="col-md-4">
          <CountCard name="Archives" path="Archive" icon={<StickyNote />} />
        </div>
        <div className="col-md-4">
          <CountCard
            name="Newsletter"
            path="Newsletter"
            icon={<StickyNote />}
          />
        </div>
        <div className="col-md-4">
          <CountCard name="Authors" path="authors" icon={<UserRound />} />
        </div>
        <div className="col-md-4">
          <CountCard name="Categories" path="categories" icon={<List />} />
        </div>
      </div>
    </main>
  );
}
